var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLostHeaderTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 167,
    viewBox: "0 0 1080 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226 118.371C198.4 152.76 175.5 160.358 160.5 164.856C147.5 167.856 125 169.355 108.5 157.859C92 146.362 52 114.372 26.5 113.372C6.09998 112.573 0.333374 105.708 0 102.376V0H1080V37.8955C1073.33 38.8952 391 42.5 340 53.5C289 64.5 260.5 75.384 226 118.371Z",
    fill: "#00C0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLostHeaderTablet);
export default __webpack_public_path__ + "static/media/BlueLostHeaderTablet.329df8d6c1e0f9705023.svg";
export { ForwardRef as ReactComponent };